import { isLooseEqual } from '@app/utils/equality';

/** 문의 상세의 객실 요금·변경 이력·여행사 상세 보조 패널 고정 폭이다. */
export const INQUIRY_LEFT_POPUP_WIDTH = 390;

/**
 * 현재 상세 문의와 같은 예약의 열린 채팅방 ID를 반환한다.
 * API와 URL에서 ID 타입이 다를 수 있으므로 기존 시스템과 동일한 느슨한 비교를 사용한다.
 */
export function resolveDockedRoomId(chattingRooms, currentInquiryId) {
  if (currentInquiryId == null || !Array.isArray(chattingRooms)) return null;

  const matchingRoom = chattingRooms.find(
    (room) => room?.open === true && isLooseEqual(room?.id, currentInquiryId),
  );

  return matchingRoom?.id ?? null;
}

/** 현재 채팅방이 상세 옆에 도킹된 한 개의 채팅방인지 판정한다. */
export function isDockedRoom(room, dockedRoomId) {
  return dockedRoomId != null && isLooseEqual(room?.id, dockedRoomId);
}

/** AuthLayout의 플로팅 목록에서 도킹 중인 채팅방만 제외한다. */
export function filterFloatingChatRooms(chattingRooms, dockedRoomId) {
  if (!Array.isArray(chattingRooms)) return [];
  return chattingRooms.filter((room) => !isDockedRoom(room, dockedRoomId));
}

/**
 * 상세 내부 보조 패널이 PageContainer 경계를 벗어나 왼쪽 메뉴 뒤로 숨지 않도록
 * 사이드뷰 폭과 컨테이너 안에 남은 공간 중 작은 값을 반환한다.
 */
export function resolveLeftPopupRight(sideViewContainer) {
  const pageSideView = sideViewContainer?.closest?.(
    '[data-testid="page-side-view"]',
  );
  const pageContainer = pageSideView?.parentElement;
  const sideViewWidth = pageSideView?.offsetWidth;
  const pageContainerWidth = pageContainer?.offsetWidth;

  if (sideViewWidth == null) return sideViewContainer?.parentNode?.offsetWidth;
  if (pageContainerWidth == null) return sideViewWidth;

  return Math.min(
    sideViewWidth,
    pageContainerWidth - INQUIRY_LEFT_POPUP_WIDTH,
  );
}
